/**
 * Essa classe só existe por motivos de: TEGRA
 * Ela precisa ser refeita e os dados devem ficar alocado no bando de dados
 */

export class ParceirosUtil {
	static getParceiroTheme(parceiro: number) {
		// Parceiros TEGRA
		if ([1421, 3262, 3224, 3835].includes(parceiro)) {
			return {
				logo: '/assets/logos/tegra-logo.jpg',
				primaryColor: '#EBB92D',
				secondaryColor: '#000'
			}
		}

		return null
	}
}
